/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { requestEmailChangeV3 } from '../fn/users/request-email-change-v-3';
import { RequestEmailChangeV3$Params } from '../fn/users/request-email-change-v-3';
import { requestPasswordChangeV3 } from '../fn/users/request-password-change-v-3';
import { RequestPasswordChangeV3$Params } from '../fn/users/request-password-change-v-3';
import { verifyEmailChangeV3 } from '../fn/users/verify-email-change-v-3';
import { VerifyEmailChangeV3$Params } from '../fn/users/verify-email-change-v-3';


/**
 * User lifecycle management including creation, modification, role assignments, password management, email changes, and user-specific operations across organizations
 */
@Injectable({ providedIn: 'root' })
export class UsersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `requestPasswordChangeV3()` */
  static readonly RequestPasswordChangeV3Path = '/users/keycloak/request-password-change';

  /**
   * Request email for password change.
   *
   * Request the email for password change. Keycloak will send an email
   * to the user with a link to change the password.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `requestPasswordChangeV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  requestPasswordChangeV3$Response(params?: RequestPasswordChangeV3$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = requestPasswordChangeV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Request email for password change.
   *
   * Request the email for password change. Keycloak will send an email
   * to the user with a link to change the password.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `requestPasswordChangeV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  requestPasswordChangeV3(params?: RequestPasswordChangeV3$Params, context?: HttpContext): Observable<void> {
    const resp = this.requestPasswordChangeV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `requestEmailChangeV3()` */
  static readonly RequestEmailChangeV3Path = '/users/request-email-change';

  /**
   * Change email address and request verification codes.
   *
   * Starts the two-factor email change flow.
   * A verification code will be sent to the current email address,
   * and another one to the new email address. Both codes must later
   * be provided to confirm the change.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `requestEmailChangeV3()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  requestEmailChangeV3$Response(params: RequestEmailChangeV3$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = requestEmailChangeV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Change email address and request verification codes.
   *
   * Starts the two-factor email change flow.
   * A verification code will be sent to the current email address,
   * and another one to the new email address. Both codes must later
   * be provided to confirm the change.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `requestEmailChangeV3$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  requestEmailChangeV3(params: RequestEmailChangeV3$Params, context?: HttpContext): Observable<void> {
    const resp = this.requestEmailChangeV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `verifyEmailChangeV3()` */
  static readonly VerifyEmailChangeV3Path = '/users/verify-email-change';

  /**
   * Verify email change with codes.
   *
   * Completes the two-factor email change flow.
   * Requires the 6-digit code sent to the current email address and
   * the 6-digit code sent to the new email address.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyEmailChangeV3()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyEmailChangeV3$Response(params: VerifyEmailChangeV3$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = verifyEmailChangeV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Verify email change with codes.
   *
   * Completes the two-factor email change flow.
   * Requires the 6-digit code sent to the current email address and
   * the 6-digit code sent to the new email address.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `verifyEmailChangeV3$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyEmailChangeV3(params: VerifyEmailChangeV3$Params, context?: HttpContext): Observable<void> {
    const resp = this.verifyEmailChangeV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
